import * as Sentry from "@sentry/react";
import thunk from "redux-thunk";
import { Action, AnyAction, Dispatch, Store, applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";

import rootReducer from "./reducers";
import { ReduxApplicationState } from "../types/ReduxTypes/ReduxApplicationState";

// Additional props for connected React components. This prop is passed by default with `connect()`
export interface ConnectedReduxProps<A extends Action = AnyAction> {
  dispatch: Dispatch<A>;
}

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  // Optionally pass options listed below
});

/**
 * Create the store with dynamic reducers
 */
export default function configureStore(initialState?: Partial<ReduxApplicationState>): Store<ReduxApplicationState> {
  const middlewares = [thunk];
  const composeEnhancers = composeWithDevTools({ trace: true });
  const store = createStore(
    rootReducer(),
    initialState,
    composeEnhancers(applyMiddleware(...middlewares), sentryReduxEnhancer),
  );
  return store;
}

export const store = configureStore();
